import { isEmptyArray } from '@autobest-ui/utils';
import lazy from '../utils/lazy';

/**
 * 对route进行递归，在最下面补充未匹配路由，不改变整体UI结构的情况下，局部显示404
 * @param routes
 */
export default function extendNotFound(routes: RouteInfo[]): RouteInfo[] {
  if (isEmptyArray(routes)) {
    return routes;
  }

  return [
    ...routes,
    {
      path: '*',
      exact: true,
      component: lazy(() => import('./NotFound'))
    }
  ].map((item: RouteInfo) => {
    item.routes = extendNotFound(item.routes);
    return item;
  });
}
